import { useContext, useEffect, useRef, useState } from 'react'
import moment from 'moment'
import axios from 'axios'

import { WebSocketContext } from '../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../Providers/CondominiosContext/CondominiosContext'
import { requisicaoDguard } from '../Pages/MonitoramentoPage/GridCameras/timer'
import { showNotify } from '../Utils/Utils'

const useVideo = (eventId, cameraId, setOpen) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { condominios } = useContext(CondominiosContext)

    const [loading, setLoading] = useState(true)
    const imgRef = useRef()
    const [dguard, setDguard] = useState({})

    const [videoLink, setVideoLink] = useState('')
    const [tipoCamera, setTipoCamera] = useState(0)
    const [linkBenuvem, setlinkBenuvem] = useState('')

    useEffect(() => {
        addRoute('getVideo#video', video)

        sendWs('getVideo#video', { eventId, cameraId })

        return () => pause()
    }, [])

    const pause = () => {
        sendWs('pauseVideo', {})
    }

    const video = async (msg) => {
        if (loading) {
            setLoading(false)
        }

        if (msg && msg.data) {
            const { status, message, tipo } = msg.data
            if (status === 'error' || !status) {
                showNotify('error', message, { autoClose: 3000 })
                setOpen(false)
                return false
            }

            let urlImg = ""
            if (tipo && tipo == 1) { // Digifort
                // const { data } = msg.data.data
                // if (data) {
                //     urlImg = 'data:image/png;base64, ' + Buffer.from(data).toString('base64')
                // }
                const { link } = msg.data.data
                setVideoLink(msg.data.data)
                urlImg = link
                setLoading(false)
                setTipoCamera(1)
            } else if (tipo && tipo == 2) { // Dguard
                const { link, token, id_central } = msg.data.data
                let dguard = separa_infos_dguard(link)
                let SessaoId = await get_sessaoId(token, id_central)
                if (SessaoId) {
                    dguard.sessaoid = SessaoId
                    urlImg = link + `&SessaoId=${SessaoId}&df=${moment().format('X')}`
                    dguard.link = urlImg
                    setDguard(dguard)
                    setLoading(false)
                }
                setTipoCamera(2)
            } else if (tipo && tipo == 3) { // BeNuvem
                const { token, link, id_central, camera, date_start, date_end } = msg.data.data

                let partition = 1
                let company_code = 1

                let benuvem = await buscaVideosBenuvem(partition, company_code, id_central, camera, date_start, date_end, link, token)

                let linkInvalido = benuvem == 'Canal não encontrado' || benuvem == 'Sem Video'

                if (linkInvalido) {
                    setlinkBenuvem(false)
                } else {
                    setlinkBenuvem(benuvem)
                    urlImg = benuvem
                }

                setTipoCamera(3)
            }

            if (imgRef && imgRef.current) {
                imgRef.current.src = urlImg
            } else {
                if (tipo == 3) {
                    return false
                }
                setTimeout(() => {
                    video(msg)
                }, 1000)
            }
        }
    }

    const buscaVideosBenuvem = async (partition, company_code, client_code, channel, date_start, date_end, link, token) => {
        let result = ''

        let body = {
            client_code,
            partition,
            company_code,
            date_start,
            date_end,
            channel
        }

        try {
            result = await axios.post(link, body, { headers: { Authorization: `bearer ${token}` } })

            if (result.status == 200 && result.data.hasOwnProperty('records') && result.data.records) {
                if (result.data.records.length > 0) {
                    result = result.data.records
                } else {
                    result = 'Sem Video'
                }
            } else if (result.data.hasOwnProperty('message') && result.data.message == 'Canal não encontrado') {
                result = result.data.message
            } else if (result.data.hasOwnProperty('status') && result.data.status == 'Token is Expired') {
                result = result.data.status
            }
        } catch (error) {
            console.log('error ao buscar o video na benuvem, arq: useVideo.js, func: buscaVideosBenuvem()', error)
        }
        return result
    }

    const get_sessaoId = async (token, id_central) => {
        if (global.sessaoCamera == null) {
            let cond = condominios.find(cond => cond.id_central == id_central)
            const { urlCamera, urlInternoCamera } = cond
            let req = await requisicaoDguard(urlInternoCamera, token)
            if (!req.status || req.status != 200) {
                req = await requisicaoDguard(urlCamera, token)
            }
        }
        return global.sessaoCamera
    }

    const separa_infos_dguard = (link) => {
        let aux, url, porta, server, receiver, camera
        if (!link) { return { url, porta, server, receiver, camera } }

        aux = link.split('&')
        for (const param of aux) {
            const value = param.split('=')[1]
            if (param.indexOf('server') != -1) {
                server = value
            } else if (param.indexOf('receiver') != -1) {
                receiver = value
            } else if (param.indexOf('camera') != -1) {
                camera = value
            }
        }

        let aux_link = link.split(':')
        url = `${aux_link[0]}:${aux_link[1]}`
        porta = (aux_link[2].split('/'))[0]

        return { url, porta, server, receiver, camera }
    }

    return {
        imgRef,
        loading,
        pause,
        dguard,
        videoLink,
        tipoCamera,
        linkBenuvem
    }
}

export default useVideo
